import { useState } from "react";
import { Button, Modal, Font } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import { BizsolDisconnectStepper } from "@/components/atoms/BizsolDisconnectStepper";
import { color } from "@/styles/theme";
import { BizsolDisconnectModalState } from "@/store/bizsolDisconnectModalState";

type Props = {
  title: string;
  sub: string;
  onClickCancel: () => void;
  onClickDisconnect: (disconnectState: BizsolDisconnectModalState) => void;
};

export const BizsolDisconnectModalContentStep1 = ({
  title,
  onClickCancel,
  onClickDisconnect,
}: Props) => {
  const nextStep = 2;
  const [submitting, setSubmitting] = useState(false);

  const body = (
    <div>
      <BizsolDisconnectStepper step={1} />
      <Font>
        再び新しいビジネスダイレクトIDとの連携設定をするには、連携解除後に、「ユーザーID」を控えたうえ、本ユーザーのパスワードを設定し、MikatanoIDログイン画面からログインしてください。本ユーザーと新しいビジネスダイレクトIDとの連携設定が出来ます。
        <br />
        <br />
        現在のビジネスダイレクトIDとの連携を解除しますか？
        <br />
        <br />
      </Font>
    </div>
  );

  const footerButtons = (
    <>
      <Button
        type="button"
        variant="secondary"
        disabled={submitting}
        onClick={onClickCancel}
      >
        キャンセル
      </Button>
      <Button
        type="button"
        variant="destructive"
        disabled={submitting}
        onClick={() => {
          setSubmitting(true);
          onClickDisconnect({ step: nextStep, temporaryPassword: "" });
        }}
      >
        連携を解除
      </Button>
    </>
  );

  return (
    <Modal
      css={modal}
      title={title}
      body={body}
      zIndex={5}
      footerButtons={footerButtons}
      onClose={onClickCancel}
      backgroundColor={color.backgroundGray}
    />
  );
};

const modal = css({
  width: "614px",
});
